import type { ReactNode } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { ConnectorListSkeleton } from '@/components/connectors/connector-list-skeleton.atom'
import { ConnectorProviderList } from '@/components/connectors/connector-provider-list.molecule'
import { DisconnectConnectorDialog } from '@/components/connectors/disconnect-connector-dialog.molecule'
import { orgRoutes, settingsRoutes } from '@/routes/org-routes.const'

import { useConnectorsSettings } from './use-connectors-settings.hook'

export const ConnectorsListView: React.FC = (): ReactNode => {
  const { orgSlug } = useParams<{ orgSlug: string }>()
  const navigate = useNavigate()
  const settings = useConnectorsSettings()

  const handleProviderClick = (providerSlug: string): void => {
    navigate(`/${orgSlug}/${orgRoutes.settings}/${settingsRoutes.connectors}/${providerSlug}`)
  }

  if (settings.isLoading) return <ConnectorListSkeleton />

  return (
    <div className="connectors-list-view space-y-8">
      <ConnectorProviderList
        providerList={settings.providerList}
        connectionList={settings.connectionList}
        connectingProviderSlug={settings.connectingProviderSlug}
        onConnect={settings.handleConnect}
        onDisconnect={settings.handleDisconnect}
        onProviderClick={handleProviderClick}
      />
      <DisconnectConnectorDialog
        connection={settings.connectionToDisconnect}
        onClose={settings.handleDisconnectCancel}
        onConfirm={settings.handleDisconnectConfirm}
      />
    </div>
  )
}

ConnectorsListView.displayName = 'ConnectorsListView'
